import Title from '@common/Title'
const Hr = () => {
  return (
    <Title name='RH' />
  )
}

export default Hr
